import React from 'react'
import { Loader } from 'semantic-ui-react'

const LoaderCentered = () => <Loader active inline />

export default LoaderCentered;